import { CURRENCY_ISO } from "~/utils/constants";
import { RecommendedProductsService } from "~/ProductDetails/RecommendedProducts/recommendedProductsService";
import { trackUserAddRecommendedProductToCart } from "~/ProductDetails/RecommendedProducts/recommendedProductAnalytics";
import { convertFixedPriceProductToImpression, sendEvent } from "~/feature/Analytics/ga/ga";
import { AnalyticsMQ } from "~/feature/Analytics/AnalyticsMQ/AnalyticsMQ";
import { getPricePerPiece } from "~/feature/ProductDescriptor/v1/productDescriptorUtils";

AnalyticsMQ.instance.subscribe("addToCart", ({ products: p, context: { recommendationPlace, recommendationType } }) => {
  const products = Array.isArray(p) ? p : [p];

  const isRecommendation = !!recommendationType || !!recommendationPlace;
  const productRecommendation = isRecommendation
    ? {
        type: recommendationType ?? "unknown",
        place: recommendationPlace ?? "unknown",
      }
    : undefined;

  const impressions = products.map(({ product, price, quantity, packaging }) => {
    return convertFixedPriceProductToImpression({
      basic: product,
      packageCode: packaging.code,
      packageSize: packaging.size,
      price: getPricePerPiece(price),
      quantity: quantity,
      productRecommendation,
    });
  });

  sendEvent({
    event: "addToCart",
    ecommerce: {
      currencyCode: CURRENCY_ISO,
      add: {
        products: impressions,
      },
    },
  });

  type AddToCartItem = (typeof products)[0];

  function isRecommendedProduct({ product }: AddToCartItem) {
    return RecommendedProductsService.isProductRecommendedForSession(product.designation);
  }

  products.filter(isRecommendedProduct).forEach(({ product, quantity }) => {
    trackUserAddRecommendedProductToCart(product.designation, quantity);
  });
});
